import type { Component } from 'vue';

export interface FieldOverride {
    widget?: string | Component;
    label?: string;
    helpText?: string;
    placeholder?: string;
    readonly?: boolean;
    width?: number;
}

export interface AdminUIConfig {
    fieldOverrides?: Record<string, FieldOverride>;
    slots?: {
        toolbar?: Component;
        listRowExtra?: Component;
        detailHeader?: Component;
        detailFooter?: Component;
    };
    listComponentOverride?: Component;
    detailComponentOverride?: Component;
}

export const _ui: Map<string, AdminUIConfig> = new Map();
